module.exports = __webpack_public_path__ + "img/Listening.41aa0987.gif";